module.exports = __webpack_public_path__ + "static/media/logo_01.b4f5cc83.png";